<template>
  <div>
    <b-table-lite
      striped
      small
      :items="data"
      class="mb-0"
      thead-class="hidden"
      :fields="fields"
      tbody-tr-class="transform-summary-row"
      responsive
    >
      <template v-slot:cell(key)="{ item }">
        <pre class="value">{{ item.value }} </pre>
      </template>

      <template v-slot:cell(icon)>
        <i class="bi bi-arrow-right" />
      </template>

      <template v-slot:cell(value)="{ item }">
        <pre class="value">{{ item.key }} </pre>
      </template>
    </b-table-lite>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { transformers } from '@aison/migrator';

export default defineComponent({
  name: 'SimpleTransformSummary',
  components: {},
  props: {
    value: {
      type: Object as () => transformers.SimpleTransformerOptions,
      required: true,
    },
  },
  data() {
    return {
      fields: ['key', 'icon', 'value'],
    };
  },
  computed: {
    data() {
      return Object.entries(this.value.map).map(([key, value]) => ({
        key,
        value,
      }));
    },
  },
});
</script>

<style scoped>
.value {
  white-space: pre-line;
  margin: 0;
}
</style>

<style>
.transform-summary-row td {
  vertical-align: middle !important;
}
</style>
